"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addThousandSeparator = void 0;
const addThousandSeparator = (num) => {
    const parts = num.toString().split(".");
    const numberPart = parts[0];
    const decimalPart = parts[1];
    const thousands = /\B(?=(\d{3})+(?!\d))/g;
    return numberPart.replace(thousands, ",") + (decimalPart ? "." + decimalPart : "");
};
exports.addThousandSeparator = addThousandSeparator;
